// Library Class
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
// Service Class
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { PrePayService } from './../../../../services/common/pre-pay.service';
// Class
import { DashboardFilter } from '../../../../models/DashboardFilter';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { PrepayContractValidation } from '../../../../models/PrepayContractValidation';
import { Subscription } from 'rxjs';
import { CommonService } from '../../../../services/common/common.service';

@Component({
  selector: 'app-edit-prepay-request',
  templateUrl: './edit-prepay-request.component.html',
  styleUrls: ['./edit-prepay-request.component.scss']
})
export class EditPrePayRequestComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();
  ddlAccounts: any;
  contractId: string;
  supplier: string;
  company: string;
  contractDescription: string;
  prePayRequestAccount: number;
  prePayAmount: number;
  cropProtectionPrePayAmount: number;
  contractTypeList: any = [];
  errorsList: Array<string> = [];
  error = false;
  dashboardFilter: DashboardFilter;
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  accountList: any;
  prePayContractType: string;
  accessTypeMode = false;
  prepayContractValidation: PrepayContractValidation;
  selectedProgram: any;
  applyType = ' ';
  orderViewtoggle = false;
  contractData: any;
  isManual = false;
  isAuto = false;

  constructor(private localStorageService: LocalStorageService,
    private router: Router,
    private loaderService: LoaderService,
    private prePayService: PrePayService,
    private toastrService: ToastrService,
    private datePipe: DatePipe,
    private commonService: CommonService) {
    this.dashboardFilter = new DashboardFilter();
    this.prepayContractValidation = new PrepayContractValidation();
  }

  ngOnInit() {
    // Set the default value
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.prePayContractType = '';
    this.loaderService.setLoaderStatus(true);
    this.getAccountData();

    this.getContractTypeData();

    this.contractData = this.prePayService.getPrePayContractData();
    if (this.contractData) {
      this.contractId = this.contractData.contractId;
      this.supplier = this.contractData.supplier;
      this.prePayContractType = this.contractData.contractType;
      this.prePayRequestAccount = this.contractData.accountNo;
      this.company = this.contractData.company;
      this.contractDescription = this.contractData.contractDescription;

      this.applyType = this.contractData.applyType;
      if (this.prePayContractType === 'CPP') {
        this.cropProtectionPrePayAmount = this.contractData.amount;
        if (this.applyType === 'Y') {
          this.isAuto = true;
          this.isManual = false;
        } else {
          this.isAuto = false;
          this.isManual = true;
        }
      } else {
        this.prePayAmount = this.contractData.amount;
      }
    } else {
      this.navigateToPrePay(); // when user has migrated directly to this page through url
    }

    this.accessTypeMode = false;
    setTimeout(x => {
      this.accessTypeMode = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.PREPAY);
    }, 500);
  }

  // Get account list
  getAccountData() {
    this.dashboardFilter.cropYear = this.headerYear;
    this.subscription.push(this.prePayService.getAccountList(this.dashboardFilter).subscribe(result => {
      this.accountList = result['accounts'];
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
    this.loaderService.setLoaderStatus(false);
  }

  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // Get Contract Type Data
  getContractTypeData() {
    this.contractTypeList.push('SEED');
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setNewPrePayPageHgt();
  }

  // set account table height
  setNewPrePayPageHgt() {
    const tableHeight = window.innerHeight - 150;
    $('.newPrePayOuter').css('max-height', tableHeight + 'px');
  }

  // change event when auto apply is changed in cpp
  applyTypeChange(type: string) {
    this.applyType = type;
  }

  // Place the request
  placeRequest() {
    this.validateUserInput();
    if (this.error === false) {
      this.loaderService.setLoaderStatus(true);

      let amount = 0;
      if (this.prePayContractType === 'CPP') {
        amount = this.cropProtectionPrePayAmount;
      } else {
        amount = this.prePayAmount;
      }

      if (amount.toString().indexOf('.') < 0 && amount.toString().length > 8) {
        amount = amount.toString().length === 9 ? (+amount / 10) : (amount.toString().length === 10 ? (+amount / 100) : +parseFloat((+amount / 1000).toString()).toFixed(2));
      }

      const data = {
        AccountNumber: this.prePayRequestAccount,
        Amount: amount,
        AutoApply: this.applyType,
        BusinessLine: '04',
        RequestType: 'U',
        ContractNumber: this.contractId,
        DateSigned: this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
        Description: this.contractDescription,
        Supplier: this.supplier,
        Company: this.company
      };
      if (this.prePayContractType === 'CPP') {
        data.AutoApply = this.applyType;
        data.BusinessLine = '02';
      }
      this.subscription.push(this.prePayService.addUpdateContractRequest(data).subscribe((result: any) => {
        if (result && result.status) {
          this.toastrService.success('Agreement Number #' + this.contractId + ' updated successfully.');
          this.loaderService.setLoaderStatus(false);
          this.navigateToPrePay();
        } else {
          this.toastrService.error('Your prepay request failed, please call WinField United customer service at 855-494-6343');
          this.loaderService.setLoaderStatus(false);
        }
      }, error => {
        this.toastrService.error('Your prepay request failed, please call WinField United customer service at 855-494-6343');
        this.loaderService.setLoaderStatus(false);
      }));
    }
  }

  validateInput() {
    if (this.error) {
      this.validateUserInput();
    }
  }

  validateUserInput() {
    this.resetValidations();
    this.error = false;
    this.errorsList = [];
    if ((this.prePayAmount === undefined || this.prePayAmount.toString().trim() === '') && this.prePayContractType === 'SEED') {
      this.errorsList.push('Please provide prepay amount');
      this.prepayContractValidation.PrepayAmount = true;
    }
    if ((this.cropProtectionPrePayAmount === undefined || this.cropProtectionPrePayAmount.toString().trim() === '') && this.prePayContractType === 'CPP') {
      this.errorsList.push('Please provide crop protection prepay amount');
      this.prepayContractValidation.CropProtectionPrePayAmount = true;
    }
    if (this.errorsList.length !== 0) {
      this.error = true;
    }
  }

  // rest validations
  resetValidations() {
    this.prepayContractValidation.Account = false;
    this.prepayContractValidation.CropProtectionPrePayAmount = false;
    this.prepayContractValidation.PrepayAmount = false;
  }

  // Go back to Prepay landing page
  navigateToPrePay() {
    this.prePayService.selectedAccount = this.prePayRequestAccount;
    this.router.navigate(['/prepay']);
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());

    this.contractData = undefined;
    this.prePayService.setPrepayContractData(this.contractData);
  }
}
